import { useEffect } from 'react';

import { broadcastRovoContextMenuVariantsToExtension } from '../utils/siteHelpers';

import { useProactiveContextMenuVariants } from './useProactiveContextMenuVariants';

// Resolves the Rovo Context Menu variants (Statsig) and broadcasts them for the
// content-script overlay to read; only re-broadcasts when the memoized POJO changes.
export const useBroadcastProactiveContextMenuVariants = (): void => {
	const proactiveContextMenuVariants = useProactiveContextMenuVariants();

	useEffect(() => {
		broadcastRovoContextMenuVariantsToExtension(proactiveContextMenuVariants);
	}, [proactiveContextMenuVariants]);
};
